<template>
  <div class="page-content payments">
    <div class="row">
      <div class="col-md-6 col-sm-6 col-xs-12">
        <manually-add-credit-card />
        <update-customer-rides v-if="isAvailableMaxRidesSubsidy" />
      </div>

      <div class="col-md-6 col-sm-6 col-xs-12">
        <pay-unpaid-rides />
        <add-partner-caller-credits />
        <remove-partner-caller-credits />
      </div>

      <div class="col-sm-12">
        <credit-card-list />
        <transactions />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { computed, onMounted } from 'vue';
import { usePartner } from '@/use/partner';
import util from '@/Utils/util';

import ManuallyAddCreditCard from '@/components/UIComponents/Payments/ManuallyAddCreditCard.vue';
import CreditCardList from '@/components/Main/Operator/Payments/CreditCardList.vue';
import AddPartnerCallerCredits from '@/components/Main/Operator/Partners/AddPartnerCallerCredits.vue';
import RemovePartnerCallerCredits from '@/components/Main/Operator/Partners/RemovePartnerCallerCredits.vue';
import Transactions from '@/components/Main/Operator/Payments/Transactions.vue';
import UpdateCustomerRides from './PartnerRideCredits/UpdateCustomerRides.vue';
import PayUnpaidRides from '@/components/Main/Operator/Payments/PayUnpaidRides.vue';

export default {
  name: 'PartnerPayments',

  components: {
    ManuallyAddCreditCard,
    CreditCardList,
    Transactions,
    AddPartnerCallerCredits,
    RemovePartnerCallerCredits,
    UpdateCustomerRides,
    PayUnpaidRides,
  },

  setup: () => {
    const { partnerInfo } = usePartner();

    const isSpecialPartner = computed(() => {
      const specialPartnerIds = [
        4145, // fresno
        18074, // hap
        18080, // brookline
        18083, // mssp
        18118, // concord
        17996, // demo
      ];

      return partnerInfo.value && specialPartnerIds.includes(partnerInfo.value.id);
    });

    const isAvailableMaxRidesSubsidy = computed(() => {
      return !!partnerInfo.value?.maxRides;
    });

    onMounted(util.moveToTop);

    return {
      util,
      isSpecialPartner,
      isAvailableMaxRidesSubsidy,
    };
  },
};
</script>
